import '@scientist/ui/tokens';
import ReactMountController from './controller.js';
import { registerAsyncComponent, registerComponent } from './register_component.js';
import SimpleHelloReact from '../../components/SimpleHelloReact.jsx';
registerComponent('SimpleHelloReact', SimpleHelloReact);

registerAsyncComponent('RevenueRecognitionWorkbench', () => import('../../components/revenue-recognition'));

import DeliverableAssociationSelect from '../../components/DeliverableAssociationSelect/DeliverableAssociationSelect.jsx';
registerComponent('DeliverableAssociationSelect', DeliverableAssociationSelect);

import DynamicFormBuilder from '../../components/DynamicFormBuilder/DynamicFormBuilder.jsx';
registerComponent('DynamicFormBuilder', DynamicFormBuilder);

import DynamicFormPreview from '../../components/DynamicFormPreview/DynamicFormPreview.jsx';
registerComponent('DynamicFormPreview', DynamicFormPreview);

import DynamicFormEmbed from '../../components/DynamicFormEmbed/DynamicFormEmbed.jsx';

import { ProposalUploadCard } from '../../components/proposal-upload';

registerComponent('DynamicFormEmbed', DynamicFormEmbed);
registerComponent('ProposalUploadCard', ProposalUploadCard);

registerAsyncComponent(
  'GeneralChat',
  () => import('../../components/general-chat'),
);
registerAsyncComponent(
  'SearchAgentInsights',
  () => import('../../components/search-agent-insights/SearchAgentInsights'),
);

registerAsyncComponent(
  'PurchaseOrdersView',
  () => import('../../components/purchase-orders'),
);
registerAsyncComponent(
  'FavoriteProductsView',
  () => import('../../components/favorite-products'),
);
registerAsyncComponent(
  'PreviouslyPurchasedView',
  () => import('../../components/previously-purchased/PreviouslyPurchasedView'),
);
registerAsyncComponent(
  'GoodsReceiptsView',
  () => import('../../components/goods-receipts/GoodsReceiptsView'),
);
registerAsyncComponent(
  'StandingPurchaseOrdersView',
  () => import('../../components/standing-purchase-orders'),
);
registerAsyncComponent(
  'StandingPurchaseOrdersIndexView',
  () => import('../../components/standing-purchase-orders/StandingPurchaseOrdersIndexView'),
);
registerAsyncComponent(
  'CartImportsView',
  () => import('../../components/cart-imports/CartImportsView'),
);
registerAsyncComponent(
  'InvoicesView',
  () => import('../../components/invoices'),
);
registerAsyncComponent(
  'ProductHubView',
  () => import('../../components/products'),
);
registerAsyncComponent(
  'ProductDetailView',
  () => import('../../components/product-detail'),
);
registerAsyncComponent(
  'RequestsView',
  () => import('../../components/requests'),
);
registerAsyncComponent(
  'SuppliersView',
  () => import('../../components/suppliers'),
);
registerAsyncComponent(
  'AdminProvidersView',
  () => import('../../components/admin-providers'),
);
registerAsyncComponent(
  'QuoteImportsView',
  () => import('../../components/quote-imports'),
);
registerAsyncComponent(
  'ServicesView',
  () => import('../../components/services'),
);
registerAsyncComponent(
  'InternationalShipmentsView',
  () => import('../../components/international-shipments'),
);
registerAsyncComponent(
  'ApprovalsView',
  () => import('../../components/approvals'),
);
registerAsyncComponent(
  'PunchoutDiscrepanciesView',
  () => import('../../components/punchout-discrepancies'),
);
registerAsyncComponent(
  'ReviewableCatalogOrdersView',
  () => import('../../components/products/reviewable-catalog-orders'),
);
registerAsyncComponent(
  'SentCatalogOrdersView',
  () => import('../../components/products/sent-catalog-orders'),
);
registerAsyncComponent(
  'RequestFlow',
  () => import('../../components/request-flow'),
);
registerAsyncComponent(
  'RequestDashboard',
  () => import('../../components/request-dashboard'),
);
registerAsyncComponent(
  'OrderReview',
  () => import('../../components/order-review'),
);
registerAsyncComponent(
  'PricePredictionCard',
  () => import('../../components/pricing'),
);
registerAsyncComponent('ReportsSearch', () => import('../../components/reports-search'));
registerAsyncComponent(
  'SearchSpotlight',
  () => import('../../components/search-spotlight'),
);
registerAsyncComponent(
  'SowTemplateForm',
  () => import('../../components/SowTemplateForm'),
);
registerAsyncComponent(
  'QgMilestoneTemplatesForm',
  () => import('../../components/QgMilestoneTemplatesForm'),
);
registerAsyncComponent(
  'RfxServiceLineItemsForm',
  () => import('../../components/RfxServiceLineItemsForm'),
);
registerAsyncComponent(
  'ProposalMilestonesForm',
  () => import('../../components/ProposalMilestonesForm'),
);
registerAsyncComponent(
  'StorefrontHomepageView',
  () => import('../../components/storefront-homepage'),
);
registerAsyncComponent(
  'GlobalChatPanel',
  () => import('../../components/global-chat-panel'),
);
registerAsyncComponent(
  'ProviderInvoiceLineItems',
  () => import('../../components/ProviderInvoiceLineItems'),
);
registerAsyncComponent(
  'GplCompareView',
  () => import('../../components/gpl'),
);
registerAsyncComponent(
  'GplCompareBar',
  () => import('../../components/gpl'),
);
registerAsyncComponent(
  'GplListingActions',
  () => import('../../components/gpl'),
);
registerAsyncComponent(
  'GplMemberList',
  () => import('../../components/gpl'),
);

export default ReactMountController;
